import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Input.scss';


const Input = ({ variantClasses = [], id, type, value, readOnly, inputChange, inputBlur = () => {}, isError = false, placeholder = ' ', defaultValue = '', label = null, ...props }) => {
	const inputChangeHandlar = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		inputChange($input.id, $input.value);
	};

	const inputBlurHandler = (e) => {
		const $input = e.currentTarget;
		inputBlur($input.id, $input.value);
	};

	const inputClasses = [s.input];
	const labelClasses = [s.label];

	if (!Array.isArray(variantClasses)) variantClasses = [variantClasses.toString()];
	variantClasses.filter((c) => !!c).forEach((c) => {
		if (c.indexOf('label') !== -1) labelClasses.push(s[c]);
		else inputClasses.push(s[c]);
	});

	if (isError === true) {
		labelClasses.push(s.label__error);
		inputClasses.push(s.input__error);
	}

	if (readOnly) props.tabIndex = -1;

	const input = <input className={inputClasses.join(' ')} id={id} name={id} readOnly={readOnly} type={type} value={value || defaultValue} placeholder={placeholder} onChange={inputChangeHandlar} onBlur={inputBlurHandler} {...props} />;

	if (label) {
		return (
			<label className={labelClasses.join(' ')} htmlFor={id}>
				{ input }
				<span className={s.input_labelText}>{ label }</span>
			</label>
		);
	}
	return input;
};

export default hot(module)(Input);
